import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'
import data from '@/components/Feature/Rankings/Data'
import Ranking from '@/components/Feature/Rankings/Ranking'
import TitleSelector from '@/components/Feature/Rankings/TitleSelector'
import { CalidadDeLosAcademicos } from '@/components/Feature/Rankings/Output'

const IndexPage = () => {
  const rankings = data.filter(item => item.name === 'Rankings')[0].rankings
  const datalocal = rankings.find(
    item =>
      item.link ===
      '/rankings-generales/percepcion-de-calidad-de-los-academicos/',
  )

  return (
    <Layout>
      <SEO
        title={datalocal.name}
        keywords={[
          `La Tercera`,
          `${datalocal.name}`,
          `Ranking de Universidades Chilenas 2021`,
        ]}
      />
      <Content>
        <TitleSelector
          pretitle="Ranking de Universidades 2021"
          allRankings={rankings}
          section="rankings-generales"
          sectionSlug={datalocal.slug}
        />
        <Columns>
          <p>
            Excelencia y prestigio académico son factores que buscan las
            universidades para diferenciarse. Una forma de medirlos es a través
            del nivel de formación de los profesores que conforman el cuerpo
            docente de un plantel.
          </p>

          <p>
            El informe sobre la caracterización del personal académico,
            publicado por el SIES en octubre pasado, señala que en 2021 son 82
            mil los académicos que trabajan en instituciones de educación
            superior. De éstos, 32% realizó un magíster y solo 16% un doctorado.
          </p>

          <p>
            Este ranking mide el nivel de formación de los académicos en
            Jornadas Completas Equivalentes (JCE), estándar utilizado
            internacionalmente porque permite considerar la importancia relativa
            de un profesor de acuerdo a los horas contratadas semanalmente. Una
            JCE corresponde a 44 horas semanales de contrato.
          </p>

          <p>
            Es importante destacar qué si se consideran las JCE, y no
            simplemente el número de académicos, el porcentaje de docentes con
            estudios de posgrado en nuestro sistema se eleva a 61%, de los
            cuales un 26% posee grado de doctor, ello se explica porque las
            personas con este nivel de formación están contratadas por un mayor
            número de horas.
          </p>

          <p>
            Y mientras en las universidades de clase mundial el cuerpo docente
            es conformado mayoritariamente por profesores con doctorado, en
            nuestro sistema universitario aún es un bien escaso: de las 43 casas
            de estudio que integran el ranking, sólo ocho tienen más del 50% de
            sus JCE con este grado académico. La lista la encabezan las
            universidades Católica de Valparaíso, Adolfo Ibáñez, Alberto
            Hurtado, del Bío-Bío y de Concepción.
          </p>

          <p>
            El ranking este año lo vuelve a encabezar la U. Católica de
            Valparaíso. Se trata del plantel que registra en el mayor índice de
            JCE con doctorado: 65,4%.
          </p>

          <p>
            El principal salto en el ranking lo da la U. Católica del Maule, que
            ocupaba el puesto 19 en la versión 2020, mientras que este año se
            ubica en el 12° lugar. ¿La razón? Subió en 10 puntos porcentuales
            sus JCE con doctorado.
          </p>
        </Columns>
        <CalidadDeLosAcademicos />
        <Summary />
      </Content>
    </Layout>
  )
}

export default IndexPage
